import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import globalStore from '../store';
import FlipButton from './FlipButton';
import { toggleMuteAudio, getMuteState } from '../helper/audioHelper';
import { useTranslation } from 'react-i18next';
var AudioButton = function (props) {
    var _a = props.id, id = _a === void 0 ? 'sideBar' : _a;
    var _b = useState(!getMuteState()), isAudioON = _b[0], setAudioON = _b[1];
    var _c = useState(''), announcement = _c[0], setAnnouncement = _c[1];
    var btnConfig = globalStore.useStoreState(function (st) { return st.jsonDataStore; }).btnConfig;
    var displayMode = globalStore.useStoreState(function (state) { return state.playerStore; }).displayMode;
    var t = useTranslation().t;
    // Initialize state from audio manager
    useEffect(function () {
        setAudioON(!getMuteState());
    }, []);
    var handleClick = function () {
        var newMuteState = toggleMuteAudio();
        var newAudioOn = !newMuteState;
        setAudioON(newAudioOn);
        setAnnouncement('');
        requestAnimationFrame(function () {
            setAnnouncement(newAudioOn ? t('text.audioOnAnnouncement') : t('text.audioOffAnnouncement'));
        });
    };
    return (_jsxs(_Fragment, { children: [_jsx(FlipButton, { tool: btnConfig.audio, defaultCSS: "sidebarBtn ".concat(id), normalCSS: "settingsBtn", active: !isAudioON, onClick: handleClick, showToolTip: true, direction: displayMode === 'smartBoard' ? 'top' : 'right', isParentRelative: displayMode === 'smartBoard', ariaLabel: isAudioON ? 'text.audioOn' : 'text.audioOff', ariaPressed: !isAudioON }), ' ', _jsx("div", { role: "status", "aria-live": "assertive", "aria-atomic": "true", className: "srOnly", children: announcement }), ' '] }));
};
export default AudioButton;
